module.exports = __webpack_public_path__ + "img/3.5b89755e.png";